import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { CaseServiceCause } from '../../cases/_types/case-service-cause';
import { CasesServicesCausesService } from '../../cases/_services/cases-services-causes.service';
import { CaseServiceReason } from '../../cases/_types/case-service-reason';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { CasesServicesReasonsService } from '../../cases/_services/cases-services-reasons.service';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { CasesServicesReasonsDetailComponent } from '../../cases-services-reasons/cases-services-reasons-detail/cases-services-reasons-detail.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-cases-services-causes-detail',
    templateUrl: './cases-services-causes-detail.component.html',
    styleUrls: ['./cases-services-causes-detail.component.scss'],
    standalone: false
})
export class CasesServicesCausesDetailComponent {
  public caseServiceCauseFormGroup!: RxFormGroup;

  public caseServiceCause: CaseServiceCause = new CaseServiceCause();
  public caseServiceCauseTypes: any[] = [];

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
    public casesServicesReasons: CaseServiceReason[] = [];

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
    private casesServicesCausesService: CasesServicesCausesService,
    public casesServicesReasonsService: CasesServicesReasonsService,
    private dialogService: DialogService
  ) {

    this.caseServiceCauseFormGroup = this.formBuilder.formGroup<CaseServiceCause>(this.caseServiceCause) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalle de tipo de causa de cancelación");
    this.topbarService.addBreadcrumb("Causa de cancelación y citas atrasadas", "/casesServicesCauses");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadCaseServiceCause(id);
    }
    this.allowWrite = this.loginService.hasPermission("CASES_TYPES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES_TYPES.DELETE");
    this.loadCaseServiceCauseTypes();
  }

  async loadCaseServiceCause(id: string) {
    this.caseServiceCause = await firstValueFrom(this.casesServicesCausesService.get(id));
    this.caseServiceCauseFormGroup.patchValue(this.caseServiceCause);
    this.loadReasons(this.lastGridEvent);
  }
  async loadReasons($event:any) {
     this.lastGridEvent = $event;
    
      let params: IParamsCollection = {
        page: { number: $event.first + 1, size: $event.rows }
      }
    let filters: any = {
       caseServiceCauseId: new Filter(FilterOperation.equals, "caseServiceCauseId"),
      };
      filters.caseServiceCauseId.value = this.caseServiceCause.id;

      if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];
  
      //creamos filtros
      params.filter = FilterBuilder.fromObject(filters).build();
  
      let response = await firstValueFrom(this.casesServicesReasonsService.all(params));
      this.casesServicesReasons = response.data;
      this.totalRecords = response.meta['total'];
  }

  loadCaseServiceCauseTypes() {
    this.caseServiceCauseTypes = this.casesServicesCausesService.caseServiceCauseTypes();
  }


  async save() {
    let valid = this.formValidationService.validateForm(this.caseServiceCauseFormGroup);
    if (valid) {
      this.caseServiceCause = Object.assign(this.caseServiceCause, this.caseServiceCauseFormGroup.value);
      let caseServiceCause = await firstValueFrom(this.casesServicesCausesService.save(this.caseServiceCause));
      this.messageService.add({ closable: true, severity: 'success', summary: "Motivo guardado correctamente." });
      this.router.navigate(['casesServicesCauses']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la causa y sus motivos asociados?",
      header: "Eliminar causa",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesServicesCausesService.delete(this.caseServiceCause.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Causa eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['casesServicesCauses']);
  }

  editReason(caseServiceReason: any){
    let ref = this.dialogService.open(CasesServicesReasonsDetailComponent, {
      closable: true,
      modal: true,
      header: 'Ficha motivo de causa',
      width: '30%',
      data: {
        caseServiceCauseId: this.caseServiceCause.id,
        Id: caseServiceReason ? caseServiceReason.id : null,
        caseServiceReasonType: this.caseServiceCause.caseServiceCauseType
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadReasons(this.lastGridEvent);
    });
  }

  deleteReason(caseServiceReason: any){
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el motivo?",
        header: "Eliminar motivo",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.casesServicesReasonsService.delete(caseServiceReason.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Motivo eliminado correctamente" });
              this.loadReasons(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }
}
